import { createAction } from "@reduxjs/toolkit";
import {
  getQrCodeTypes,
  twoFactorsTypes,
  twoFactorsEnableTypes,
  completeTwoFactorsTypes,
  disalbeTwoFactorsTypes,
  twoFactorModalType,
} from "./actionTypes";

export const getQr = createAction(getQrCodeTypes.request, (payload) => ({
  payload,
}));

export const getQrSuccess = createAction(getQrCodeTypes.success, (payload) => ({
  payload,
}));

export const getQrFailure = createAction(getQrCodeTypes.failure, (error) => ({
  payload: error,
}));

export const enableTwoFactors = createAction(
  twoFactorsEnableTypes.request,
  (payload) => ({ payload }),
);

export const enableTwoFactorsSuccess = createAction(
  twoFactorsEnableTypes.success,
  (payload) => ({ payload }),
);

export const enableTwoFactorsFailure = createAction(
  twoFactorsEnableTypes.failure,
  (error) => ({ payload: error }),
);

export const completeTwoFactors = createAction(
  completeTwoFactorsTypes.request,
  (payload) => ({ payload }),
);

export const completeTwoFactorsSuccess = createAction(
  completeTwoFactorsTypes.success,
  (payload) => ({ payload }),
);

export const completeTwoFactorsFailure = createAction(
  completeTwoFactorsTypes.failure,
  (error) => ({ payload: error }),
);

export const disableTwoFactors = createAction(
  disalbeTwoFactorsTypes.request,
  (payload) => ({ payload }),
);

export const disableTwoFactorsSuccess = createAction(
  disalbeTwoFactorsTypes.success,
);

export const disableTwoFactorsFailure = createAction(
  disalbeTwoFactorsTypes.failure,
  (error) => ({ payload: error }),
);

export const twoFactorsReset = createAction(twoFactorsTypes.reset);

export const toggleTwoFactorsModal = createAction(twoFactorModalType);
